"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.staggerIn = exports.slideUpExit = exports.slideUpEnter = exports.rotate = exports.rollDown = exports.moveUpRotateExit = exports.moveUpRotateEnter = exports.moveUpFixed = exports.moveUpAndDown = exports.fade = void 0;
/**
 * Fade Animation
 *
 * @param {number} start start opacity percent
 * @param {number} end end opacity percent
 * @param {string} duration animation duration in ms
 * @returns {string} template literal
 * @public
 */
const fade = (start, end, duration) => {
  return `
    animation: fade ${duration};
    @keyframes fade {
      0% {
        opacity: ${start}%;
      }

      100% {
        opacity: ${end}%;
      }
    }
  `;
};

/**
 * Roll Down Animation
 *
 * @param {string} start start max-height value
 * @param {string} end end max-height value
 * @param {string} duration animation duration in ms
 * @returns {string} template literal
 * @public
 */
exports.fade = fade;
const rollDown = (start, end, duration) => {
  return `
    animation: rollDown ${duration} linear;
    @keyframes rollDown {
    0% {
      max-height: ${start};
    }

    100% {
      max-height: ${end};
    }
  `;
};

/**
 * Rotate Animation
 *
 * @param {string} value rotate value
 * @param {number} duration animation duration in ms
 * @returns {string} template literal
 * @public
 */
exports.rollDown = rollDown;
const rotate = (value, duration) => {
  return `
    transition: transform ${duration};
    transform-origin: center;
    transform: rotate(${value});
  `;
};

/**
 * MoveUpAndDown Animation
 *
 * @param {string} start start max-height value
 * @param {string} end end max-height value
 * @param {string} duration animation duration in ms
 * @returns {string} vertical transition value
 * @public
 */
exports.rotate = rotate;
const moveUpAndDown = (start, end, duration) => {
  return `
    animation: moveUpAndDown ${duration}s ease-in-out forwards infinite;
    @keyframes moveUpAndDown {
      0%, 100% {
        transform: translateY(${start}rem);
      }
  
      50% {
        transform: translateY(${end}rem);
      }
    }
  `;
};
exports.moveUpAndDown = moveUpAndDown;
const moveUpFixed = (duration, translateY) => {
  return `
    animation: moveUpFixed ${duration} ease forwards;
    @keyframes moveUpFixed {
      0% {
        opacity: 0;
        transform: translateY(${translateY});
      }
      100% {
        opacity: 1;
        transform: translateY(0);
      }
    }
  `;
};
exports.moveUpFixed = moveUpFixed;
const staggerIn = (duration, start, end) => {
  return `
  animation: staggerIn ${duration};
  animation-delay: calc(var(--index) * 100ms);
  animation-fill-mode: both;
  will-change: opacity, transform;
  @keyframes staggerIn {
    0% {
      opacity: 0;
      transform: ${start};
    }
    100% {
      opacity: 1;
      transform: ${end};
    }
  }
}
`;
};
exports.staggerIn = staggerIn;
const moveUpRotateEnter = (duration = 1) => {
  return `
    animation: enter ${duration}s cubic-bezier(0.25, 0.61, 0.35, 1) forwards;

    @keyframes enter {
      from {
        transform: rotateX(-90deg) translate3d(0, 100%, 0);
        opacity: 0;
      }
      to {
        transform: rotateX(0) translate3d(0, 0, 0);
        opacity: 1;
      }
    }
  `;
};
exports.moveUpRotateEnter = moveUpRotateEnter;
const moveUpRotateExit = (duration = 1) => {
  return `
    animation: exit ${duration}s cubic-bezier(0.25, 0.61, 0.35, 1) forwards;

    @keyframes exit {
      from {
        transform: rotateX(0deg) translate3d(0, 0, 0);
        opacity: 1;
      }
      to {
        transform: rotateX(90deg) translate3d(0, -100%, 0);
        opacity: 0;
      }
    }
  `;
};
exports.moveUpRotateExit = moveUpRotateExit;
const slideUpEnter = (duration = 1) => {
  return `
    animation: enterSlide ${duration}s cubic-bezier(0.46, 0.03, 0.52, 0.96) forwards;

    @keyframes enterSlide {
      from {
        transform: translate3d(0, 100%, 0);
        opacity: 0;
      }
      to {
        transform: translate3d(0, 0, 0);
        opacity: 1;
      }
    }
  `;
};
exports.slideUpEnter = slideUpEnter;
const slideUpExit = (duration = 1) => {
  return `
    animation: exitSlide ${duration}s cubic-bezier(0.46, 0.03, 0.52, 0.96) forwards;

    @keyframes exitSlide {
      from {
        transform: translate3d(0, 0, 0);
        opacity: 1;
      }
      to {
        transform: translate3d(0, -100%, 0);
        opacity: 0;
      }
    }
  `;
};
exports.slideUpExit = slideUpExit;